/**
 * Conditional logic module containing utility functions that evaluate and transform
 * form data based on conditional dependencies. These functions implement business logic
 * for determining derived values and state based on form conditions.
 */

import { isServingComponentGuardAndReserves } from './pageDependencies';
import { RESERVE_COMPONENT_LABELS } from '../constants';

export const getServiceComponent = formData => {
  if (isServingComponentGuardAndReserves(formData)) {
    return formData?.serviceInformation?.reservesNationalGuardService
      ?.component;
  }
  if (formData?.serviceInformation?.serviceComponent?.reserves) {
    return 'RESERVES';
  }
  if (formData?.serviceInformation?.serviceComponent?.nationalGuard) {
    return 'NATIONAL_GUARD';
  }
  return null;
};

export const getPageTitle = ({ formData, text }) => {
  const component = getServiceComponent(formData);
  if (!component) {
    return text.split(' ').slice(0, -2).join(' ');
  }
  const name = RESERVE_COMPONENT_LABELS[component];
  return `${text} ${name}`;
};
